<template>
  <ModalDialog
    ref="dialog"
    title="Close Overpayment"
    icon="fa-check-circle"
    :showFooter="true"
    :submitting="submitting"
    closeTitle="Close"
    submitTitle="Update"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="form" :labelColumnSize="3">
      <NotificationBar type="warning">
        <NotificationBarTitle>This will manually close the overpayment and mark it as allocated</NotificationBarTitle>
        <ul>
          <li>This is a manual process to flag overpayments as allocated and close them off.</li>
          <li>Invoice allocations will <strong>NOT</strong> match the total overpayment amount.</li>
          <li>The remaining credit amount will be set to {{formatCurrency(0)}} and the overpayment will no longer be available for further allocations.</li>
          <li>Overpayment&apos;s cannot be closed if there are pending orders linked to this overpayment. They must be invoiced first.</li>
        </ul>

        <template v-if="hasXeroIntegration">
          <strong>Xero Users</strong>
          <ul>
            <li>After closing an overpayment, please access Xero to ensure the linked overpayment is manually closed too</li>
          </ul>
        </template>
      </NotificationBar>
      
      <FormRow label="Closing Reason">
        <FormInputTextArea ref="textEntryArea" v-model="closeReason" placeholder="Enter reason and details for closing the overpayment" field="reason" />
      </FormRow>
      
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'

import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

export default {
  name: 'OverPaymentCloseDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog,
  },
  props: {
    overPaymentId: Number
  },
  data() {
    return {
      form: {},
      submitting: false,
      closeReason: ''
    }
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    show() {
      this.form = {}
      this.submitting = false

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },
    onSubmitted() {
      this.form = this.clearFormResponse()
      this.submitting = true

      var updateData = {
        reason: this.closeReason
      }

      this.$apiService.accountsService.closeOverpayment(this.overPaymentId, updateData)
      .then(response => {
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.form = this.processFormResponse(err)
      })
      .finally(() => {
        this.submitting = false
      })
    }
  }
}
</script>